// Fonte: UOcoConta.pas (1.820 linhas) — CRUD de ocorrencias/notas da conta
// Correcao: adicionados lookups Atendimento + SubTipo, canal como enum, titulo derivado automaticamente
import React, { useState, useEffect, useCallback } from 'react';
import { Table, Button, Form, Modal, Spinner, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Select from 'react-select';
import {
  listarOcorrenciasConta,
  inserirOcorrenciaConta,
  atualizarOcorrenciaConta,
  excluirOcorrenciaConta,
  listarAtendimentosOcorrencia,
  listarSubtiposAtendimento,
} from '~/Services/Service';
import { FaSearch } from 'react-icons/fa';
import moment from 'moment';

// Fonte: UOcoConta.pas, RetornaCanalAtendimento, linhas 466-481
var CANAL_OPTS = [
  { value: 'T', label: 'Telefone Ativo' },
  { value: 'P', label: 'Presencial' },
  { value: 'E', label: 'Email' },
  { value: 'I', label: 'Back Office' },
  { value: 'R', label: 'Rede Social' },
  { value: 'W', label: 'Whatsapp' },
  { value: 'A', label: 'Reclame Aqui' },
  { value: 'N', label: 'Interno' },
];

// Mapa para exibir label do canal na grid
var CANAL_MAP = {};
CANAL_OPTS.forEach(function(c) { CANAL_MAP[c.value] = c.label; });

var VAZIO = {
  data_ocorrencia: '',
  codigo_atendimento: null,
  codigo_subtipo: null,
  titulo: '',
  texto_ocorrencia: '',
  ticket: '',
  canal: '',
};

var TabOcorrencias = function(_ref) {
  var ge = _ref.ge;
  var codigo = _ref.codigo;

  var [ocorrencias, setOcorrencias] = useState([]);
  var [loading, setLoading] = useState(false);
  var [showModal, setShowModal] = useState(false);
  var [editando, setEditando] = useState(null);
  var [form, setForm] = useState(VAZIO);
  var [salvando, setSalvando] = useState(false);
  var [showExcluir, setShowExcluir] = useState(null);
  var [showTexto, setShowTexto] = useState(null);

  // Lookups
  var [atendimentos, setAtendimentos] = useState([]);
  var [subtipos, setSubtipos] = useState([]);
  var [carregandoSubtipos, setCarregandoSubtipos] = useState(false);

  // Carregar lista de atendimentos uma vez
  useEffect(function() {
    listarAtendimentosOcorrencia()
      .then(function(resp) {
        var data = Array.isArray(resp) ? resp : [];
        setAtendimentos(data.map(function(a) {
          return { value: a.codigo, label: a.descricao !== null && a.descricao !== undefined ? a.descricao : String(a.codigo) };
        }));
      })
      .catch(function() { /* lookup opcional — se endpoint nao existir, segue sem */ });
  }, []);

  // Carregar subtipos quando atendimento mudar
  useEffect(function() {
    if (!form.codigo_atendimento) {
      setSubtipos([]);
      return;
    }
    setCarregandoSubtipos(true);
    listarSubtiposAtendimento(form.codigo_atendimento)
      .then(function(resp) {
        var data = Array.isArray(resp) ? resp : [];
        setSubtipos(data.map(function(s) {
          return { value: s.codigo, label: s.descricao !== null && s.descricao !== undefined ? s.descricao : String(s.codigo) };
        }));
      })
      .catch(function() { setSubtipos([]); })
      .finally(function() { setCarregandoSubtipos(false); });
  }, [form.codigo_atendimento]);

  // Fonte: UOcoConta.pas, MontaTitulo, linha ~620
  // Derivar titulo automaticamente = Atendimento - SubTipo
  useEffect(function() {
    var atendLabel = '';
    if (form.codigo_atendimento) {
      var atOpt = atendimentos.find(function(a) { return a.value === form.codigo_atendimento; });
      if (atOpt) atendLabel = atOpt.label;
    }
    setForm(function(f) { return { ...f, titulo: atendLabel }; });
  }, [form.codigo_atendimento, atendimentos]);

  var carregar = useCallback(function() {
    if (!ge || !codigo) return;
    setLoading(true);
    listarOcorrenciasConta(ge, codigo)
      .then(function(resp) {
        setOcorrencias(Array.isArray(resp) ? resp : []);
      })
      .catch(function() { toast.error('Erro ao carregar ocorrencias'); })
      .finally(function() { setLoading(false); });
  }, [ge, codigo]);

  useEffect(function() { carregar(); }, [carregar]);

  var handleNova = function() {
    setEditando(null);
    setForm({ ...VAZIO, data_ocorrencia: moment().format('YYYY-MM-DD') });
    setSubtipos([]);
    setShowModal(true);
  };

  var handleEditar = function(oc) {
    setEditando(oc);
    setForm({
      data_ocorrencia: oc.data_ocorrencia ? moment(oc.data_ocorrencia).format('YYYY-MM-DD') : '',
      codigo_atendimento: oc.codigo_atendimento !== null && oc.codigo_atendimento !== undefined ? oc.codigo_atendimento : null,
      codigo_subtipo: oc.codigo_subtipo !== null && oc.codigo_subtipo !== undefined ? oc.codigo_subtipo : null,
      titulo: oc.titulo !== null && oc.titulo !== undefined ? oc.titulo : '',
      texto_ocorrencia: oc.texto_ocorrencia !== null && oc.texto_ocorrencia !== undefined ? oc.texto_ocorrencia : '',
      ticket: oc.ticket !== null && oc.ticket !== undefined ? oc.ticket : '',
      canal: oc.canal !== null && oc.canal !== undefined ? oc.canal : '',
    });
    setShowModal(true);
  };

  var handleSalvar = function() {
    // Fonte: UOcoConta.pas, BGraClick — validacoes obrigatorias
    if (!form.canal) { toast.warning('Selecione o canal de atendimento'); return; }
    if (!form.codigo_atendimento) { toast.warning('Selecione o tipo de atendimento'); return; }
    if (subtipos.length > 0 && !form.codigo_subtipo) { toast.warning('Selecione o subtipo de atendimento'); return; }
    if (!form.texto_ocorrencia) { toast.warning('Informe o texto da ocorrência'); return; }

    setSalvando(true);
    var payload = {
      ...form,
      data_ocorrencia: editando ? editando.data_ocorrencia : form.data_ocorrencia,
    };
    if (editando) {
      payload.data_ocorrencia_original = editando.data_ocorrencia;
    }
    var fn = editando
      ? atualizarOcorrenciaConta(ge, codigo, payload)
      : inserirOcorrenciaConta(ge, codigo, payload);
    fn
      .then(function() {
        toast.success('Ocorrencia salva!');
        setShowModal(false);
        carregar();
      })
      .catch(function() { toast.error('Erro ao salvar ocorrência'); })
      .finally(function() { setSalvando(false); });
  };

  var handleExcluir = function() {
    excluirOcorrenciaConta(ge, codigo, { data_ocorrencia: showExcluir.data_ocorrencia, protocolo: showExcluir.protocolo })
      .then(function(resp) {
        if (resp && resp.sucesso === false) {
          toast.warning(resp.mensagem || 'Não foi possível excluir a ocorrência');
          return;
        }
        toast.success('Ocorrencia excluida!');
        setShowExcluir(null);
        carregar();
      })
      .catch(function() { toast.error('Erro ao excluir ocorrência'); });
  };

  return (
    <div className="contas-tab-content">
      <div className="d-flex justify-content-end mb-2">
        <Button size="sm" variant="primary" onClick={handleNova}>+ Nova Ocorrencia</Button>
      </div>
      {loading ? (
        <div className="text-center py-3"><Spinner animation="border" /></div>
      ) : (
        <Table size="sm" bordered className="contas-sub-grid">
          <thead>
            <tr>
              <th style={{ width: '95px' }}>Data</th>
              <th>Título</th>
              <th style={{ width: '110px' }}>Canal</th>
              <th style={{ width: '120px' }}>Usuario</th>
              <th style={{ width: '80px' }}>Ticket</th>
              <th style={{ width: '45px' }}></th>
            </tr>
          </thead>
          <tbody>
            {ocorrencias.length === 0 ? (
              <tr><td colSpan={6} className="text-center text-muted">Nenhuma ocorrência</td></tr>
            ) : (
              ocorrencias.map(function(oc, idx) {
                var key = oc.data_ocorrencia ? moment(oc.data_ocorrencia).toISOString() + '_' + idx : 'oc_' + idx;
                return (
                  <tr key={key}>
                    <td>{oc.data_ocorrencia ? moment(oc.data_ocorrencia).format('DD/MM/YYYY') : '-'}</td>
                    <td>
                      {oc.titulo !== null && oc.titulo !== undefined ? oc.titulo : '-'}
                      {oc.manual === 'S' && (
                        <span className="float-right">
                          <Button size="sm" variant="outline-primary" className="mr-1 py-0 px-1" style={{ fontSize: '0.75rem' }} onClick={function() { handleEditar(oc); }}>Editar</Button>
                          <Button size="sm" variant="outline-danger" className="py-0 px-1" style={{ fontSize: '0.75rem' }} onClick={function() { setShowExcluir(oc); }}>Excluir</Button>
                        </span>
                      )}
                    </td>
                    <td>{oc.canal ? (CANAL_MAP[oc.canal] || oc.canal) : '-'}</td>
                    <td>{oc.nome_usuario !== null && oc.nome_usuario !== undefined ? oc.nome_usuario : '-'}</td>
                    <td>{oc.ticket !== null && oc.ticket !== undefined ? oc.ticket : '-'}</td>
                    <td style={{ textAlign: 'center' }}>
                      {oc.texto_ocorrencia ? (
                        <FaSearch style={{ cursor: 'pointer', color: '#007bff' }} title="Ver texto"
                          onClick={function() { setShowTexto(oc); }} />
                      ) : '-'}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      )}

      {/* Modal Ocorrencia */}
      <Modal show={showModal} onHide={function() { setShowModal(false); }} size="lg">
        <Modal.Header closeButton className="contas-modal-header">
          <Modal.Title>{editando ? 'Editar Ocorrência' : 'Nova Ocorrência'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Data</Form.Label>
                <Form.Control type="date" size="sm" value={form.data_ocorrencia}
                  onChange={function(e) { var v = e.target.value; setForm(function(f) { return { ...f, data_ocorrencia: v }; }); }} />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label className="small">Canal *</Form.Label>
                <Select
                  placeholder="Selecione..."
                  options={CANAL_OPTS}
                  value={CANAL_OPTS.find(function(c) { return c.value === form.canal; }) || null}
                  onChange={function(opt) { setForm(function(f) { return { ...f, canal: opt ? opt.value : '' }; }); }}
                  isClearable
                  noOptionsMessage={function() { return 'Nenhum canal'; }}
                />
              </Form.Group>
            </Col>
            <Col md={5}>
              <Form.Group>
                <Form.Label className="small">Ticket/Prot.</Form.Label>
                <Form.Control type="text" size="sm" value={form.ticket}
                  onChange={function(e) { var v = e.target.value; setForm(function(f) { return { ...f, ticket: v }; }); }} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label className="small">Atendimento *</Form.Label>
                <Select
                  placeholder="Selecione o atendimento..."
                  options={atendimentos}
                  value={atendimentos.find(function(a) { return a.value === form.codigo_atendimento; }) || null}
                  onChange={function(opt) {
                    setForm(function(f) { return { ...f, codigo_atendimento: opt ? opt.value : null, codigo_subtipo: null }; });
                    setSubtipos([]);
                  }}
                  isClearable
                  noOptionsMessage={function() { return 'Nenhum atendimento'; }}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label className="small">SubTipo {subtipos.length > 0 ? '*' : ''}</Form.Label>
                <Select
                  placeholder={carregandoSubtipos ? 'Carregando...' : 'Selecione o subtipo...'}
                  options={subtipos}
                  value={subtipos.find(function(s) { return s.value === form.codigo_subtipo; }) || null}
                  onChange={function(opt) { setForm(function(f) { return { ...f, codigo_subtipo: opt ? opt.value : null }; }); }}
                  isClearable
                  isDisabled={!form.codigo_atendimento || carregandoSubtipos}
                  isLoading={carregandoSubtipos}
                  noOptionsMessage={function() { return 'Nenhum subtipo'; }}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Form.Group>
                <Form.Label className="small">Título (derivado automaticamente)</Form.Label>
                <Form.Control type="text" size="sm" value={form.titulo} readOnly
                  style={{ backgroundColor: '#f5f5f5' }} />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group>
            <Form.Label className="small">Texto *</Form.Label>
            <Form.Control as="textarea" rows={4} value={form.texto_ocorrencia}
              onChange={function(e) { var v = e.target.value; setForm(function(f) { return { ...f, texto_ocorrencia: v }; }); }} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={function() { setShowModal(false); }}>Cancelar</Button>
          <Button variant="success" onClick={handleSalvar} disabled={salvando}>
            {salvando ? <Spinner animation="border" size="sm" /> : 'Gravar'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Visualizar texto */}
      <Modal show={!!showTexto} onHide={function() { setShowTexto(null); }}>
        <Modal.Header closeButton className="contas-modal-header">
          <Modal.Title>{showTexto ? showTexto.titulo || 'Ocorrência' : 'Ocorrência'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ whiteSpace: 'pre-wrap' }}>{showTexto ? showTexto.texto_ocorrencia : ''}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={function() { setShowTexto(null); }}>Fechar</Button>
        </Modal.Footer>
      </Modal>

      {/* Confirmar exclusao */}
      <Modal show={!!showExcluir} onHide={function() { setShowExcluir(null); }}>
        <Modal.Header closeButton className="contas-modal-header"><Modal.Title>Confirmar Exclusão</Modal.Title></Modal.Header>
        <Modal.Body>Deseja excluir a ocorrência <strong>{showExcluir && showExcluir.titulo}</strong>?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={function() { setShowExcluir(null); }}>Não</Button>
          <Button variant="danger" onClick={handleExcluir}>Excluir</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TabOcorrencias;
